// Polyfills for react-pdf and other browser compatibility issues

// Buffer polyfill for react-pdf
if (typeof window !== 'undefined' && !window.Buffer) {
  try {
    window.Buffer = require('buffer').Buffer;
  } catch (error) {
    console.warn('Buffer polyfill not available:', error);
  }
}

// Process polyfill if needed
if (typeof window !== 'undefined' && !window.process) {
  window.process = { env: {} };
}

// Global polyfill for react-pdf
if (typeof global === 'undefined') {
  window.global = window;
} 